import Axios from 'axios';
import { action, observable, computed } from 'mobx';
import { API } from '@/config/api';
import { BALANCETYPE } from '@/config/const';
import { ScrollPageInfo, PageInfo } from '@/models/data';
import { getExchangeUrl } from '@/utils/location';
import Cookies from 'js-cookie';
import { Notification } from 'element-react';
import i18n from '@/i18n';
import { BigNumber } from 'bignumber.js';
import qs from 'qs';
import { formatAssetsPrecision } from '@/utils/utils';

export interface BalanceDetail {
  coin: string; // 币种
  isolatedMargin: string; // 逐仓保证金冻结
  crossedMargin: string; // 全仓保证金冻结
  openOrderMarginFrozen: string; // 委托保证金: ∑所有委托保证金
  walletBalance: string; // 钱包余额 = 总划转入金 - 总划转出金 + 总已实现盈亏
  availableBalance: string; // 真实可用 = 钱包余额 - ∑逐仓仓位保证金 - ∑全仓起始保证金 - ∑委托保证金（不显示在c端）
  bonus: string; // 体验金
}

export interface UserLabel {
  id: number;
  label: string;
}
// 获取系统默认头像,交易员标签,带单配置信息
export interface UserConfig {
  avatar: string; // 头像
  canChangeNick: boolean; // 是否能修改用户昵称
  followCapitalMax: number; //	最大跟单本金
  autoUnfollow: boolean; // 自动跟随
  followCapitalMin: number; // 	最小跟单本金
  labelIds: string;
  labels: UserLabel[];
  id: number; // 主键ID
  nickName: string; // 昵称
  leftNickChangeNum?: number; //用户昵称可修改次数
  displayEquity?: boolean; // 显示总权益：true:展示,false:不展示
  displayPosition?: boolean; // 显示持仓量：true:展示,false:不展示
  intro: string; //简介
  openLeader: boolean;
  leaderId: any;
}
export interface BonusItem {
  [key: string]: any;
}
export interface SupportAccount {
  mainName: any[];
  transferName: any[];
  allName: any[];
}
export default class Asset {
  private readonly rootStore: any;

  @observable showAsset: boolean;

  @observable supportAccount: any;

  @observable showTransferModal: boolean;

  @observable hideZero: boolean;

  @observable financialBalance: any[];

  @observable otcBalance: any[];

  @observable spotBalance: any[];

  @observable tigerBalance: any[];
  @observable tigerSpuerBalance: any[];
  @observable copyBalance: any[];

  @observable phaseRate: number;

  @observable profitAmount: number;

  @observable totalCynAmount: number;

  @observable totalUsdtAmount: number;

  @observable wthdrawRecords: any[];

  @observable innerTransferRecords: any[] = [];

  @observable depositRecords: any[] = [];

  @observable transferRecords: any[] = [];

  @observable supportCoinList: any[];

  @observable bills: any[];

  @observable withdrawDepositRecords: any[];

  @observable wthdrawTotal: number;

  @observable depositTotal: number;

  @observable transferTimer: any;

  @observable billTypes: any[];

  @observable quota: string | number;

  @observable billPageInfo: ScrollPageInfo;

  @observable isFetchingHistory: boolean;

  @observable isFetchingWithdrawDepositRecord: boolean;

  @observable withdrawDepositRecordsPageInfo: ScrollPageInfo;

  @observable innerTransferRecordsPageInfo: ScrollPageInfo;

  @observable transferRecordsPageInfo: ScrollPageInfo;

  @observable isFetchingBalance: boolean;

  @observable userConfig: UserConfig;

  @observable profitData: any;

  constructor(rootStore: any) {
    this.rootStore = rootStore;

    this.supportAccount = []; // 支持划转的账户
    // this.supportAccountMain = [];
    // this.supportAccountTransfer=[];
    this.transferTimer = null;
    this.showTransferModal = false; // 划转modal是否展示
    this.showAsset = !!Cookies.get('showAsset');
    this.supportCoinList = []; // 支持划转的币种列表
    this.hideZero = false;
    this.financialBalance = []; // 理财资产
    this.otcBalance = []; // otc资产
    this.spotBalance = []; // 现货资产
    this.copyBalance = []; // 跟单资产
    this.tigerBalance = []; // 合约资产
    this.tigerSpuerBalance = []; //超级合约
    this.phaseRate = 0;
    this.profitAmount = 0;
    this.quota = 0; // 可用额度
    this.totalCynAmount = 0; // 总资产-转人民币
    this.totalUsdtAmount = 0; // 总资产 -转usdt
    this.wthdrawRecords = []; // 提现记录
    this.innerTransferRecords = []; // 内部转账记录
    this.depositRecords = []; // 充值记录
    this.transferRecords = []; // 划转记录
    this.bills = []; // 综合账单

    this.withdrawDepositRecords = []; // 充提记录
    this.wthdrawTotal = 0; // 提现总数
    this.depositTotal = 0; // 充值总数
    this.billTypes = []; // 综合账单类型

    this.userConfig = {
      autoUnfollow: false,
      avatar: '',
      canChangeNick: false,
      followCapitalMin: 0,
      id: 0,
      labelIds: '',
      labels: [],
      nickName: '',
      followCapitalMax: 0,
      intro: '',
      openLeader: true,
      leaderId: '',
    };

    this.billPageInfo = {
      hasPrev: false,
      hasNext: false,
    };
    this.withdrawDepositRecordsPageInfo = {
      hasPrev: false,
      hasNext: false,
    };
    this.innerTransferRecordsPageInfo = {
      hasPrev: false,
      hasNext: false,
    };
    this.transferRecordsPageInfo = {
      hasPrev: false,
      hasNext: false,
    };
    this.profitData = {
      profitFuture: '0',
      profitRate: '0',
      profitTotal: '0',
      profitYesterday: '0',
    };
    this.isFetchingHistory = false;
    this.isFetchingBalance = false;
    this.isFetchingWithdrawDepositRecord = false;
  }

  @computed get spotAllBalance() {
    return this.spotBalance.reduce((previous, current) => previous + Number(current.estimatedTotalAmount), 0);
  }

  @computed get copyAllBalance() {
    return this.copyBalance.reduce((previous, current) => previous + Number(current.estimatedTotalAmount), 0);
  }

  @computed get superAllBalance() {
    return this.tigerSpuerBalance.reduce((previous, current) => previous + Number(current.estimatedTotalAmount), 0);
  }
  @computed get financialAllBalance() {
    return this.financialBalance.reduce((previous, current) => previous + Number(current.estimatedTotalAmount), 0);
  }

  @computed get supportAccountString() {
    return [...this.supportAccount.mainName, ...this.supportAccount.transferName].join(',');
  }

  @computed get otcAllBalance() {
    return this.otcBalance.reduce((previous, current) => previous + Number(current.estimatedTotalAmount), 0);
  }

  // 合约列表资产用这个 可用余额包括了全仓未实现盈亏 正数不加 负数相加 划转用
  // 现在划转用的是这个要再减去所有全仓仓位的unsettledProfit

  @computed get tigerBalanceProfitTransfer() {
    const crossedUnsettled = this.rootStore.futures.crossedUnsettledProfitTotal || '0';
    const positionList = this.rootStore.futures.positionListWithValue;

    return this.tigerBalance.map(item => {
      let crossedFloatProfit = new BigNumber(0);
      const coin = item.coin;
      positionList.forEach((p: any) => {
        if (p.positionType !== 'CROSSED') return;
        const isMatch = coin === 'usdt'
          ? p.symbol?.split('_')[1] === 'usdt'
          : p.symbol?.split('_')[0] === coin;
        if (isMatch) {
          crossedFloatProfit = crossedFloatProfit.plus(p.floatProfit || 0);
        }
      });

      const realTimeAvailable = BigNumber.max(
        0,
        new BigNumber(item.availableBalance).plus(crossedFloatProfit),
      );

      return {
        ...item,
        availableBalanceProfit: BigNumber.max(0, realTimeAvailable.minus(crossedUnsettled)).valueOf(),
      };
    });
  }
  // 合约列表资产用这个 可用余额包括了未实现盈亏  非划转用

  @computed get tigerBalanceProfit() {
    return this.tigerBalance.map(item => ({
      ...item,
      availableBalanceProfit: new BigNumber(item.availableBalance).plus(item.profit),
      profitTotal: new BigNumber(item.profit).plus(item.isolatedProfit || 0), // 未实现盈亏
      equityTotal: new BigNumber(item.balance).plus(item.profit).plus(item.isolatedProfit || 0), // 账户权益
      marginTotal: new BigNumber(item.profit).lt(0)
        ? new BigNumber(item.availableBalance).plus(item.profit)
        : new BigNumber(item.availableBalance), // 可用保证金
    }));
  }

  // 合约=>资产折合 //estimatedTotalAmount(balance)+全仓未实现盈亏estimatedProfit+逐仓未实现盈亏estimatedIsolatedProfit
  @computed get tigerEstimatedTotal() {
    let precision = 4;
    const coinsPrecisionList = this.rootStore.coin.coinsPrecisionList;
    if (Reflect.has(coinsPrecisionList, 'USDT')) {
      precision = this.rootStore.coin.coinsPrecisionList['USDT'];
    }
    const res = this.tigerBalance.reduce(
      (previous, current) =>
        previous +
        new BigNumber(current.estimatedTotalAmount)
          .plus(current.estimatedProfit || 0)
          .plus(current.estimatedIsolatedProfit || 0)
          .toNumber(),
      0,
    );
    return formatAssetsPrecision(res, precision);
  }

  // 跟单=>资产折合 //estimatedTotalAmount(balance)+全仓未实现盈亏estimatedProfit+逐仓未实现盈亏estimatedIsolatedProfit
  @computed get copyEstimatedTotal() {
    let precision = 4;
    const coinsPrecisionList = this.rootStore.coin.coinsPrecisionList;
    if (Reflect.has(coinsPrecisionList, 'USDT')) {
      precision = this.rootStore.coin.coinsPrecisionList['USDT'];
    }
    const res = this.copyBalance.reduce(
      (previous, current) =>
        previous +
        new BigNumber(current.estimatedTotalAmount)
          .plus(current.estimatedProfit || 0)
          .plus(current.estimatedIsolatedProfit || 0)
          .toNumber(),
      0,
    );
    return formatAssetsPrecision(res, precision);
  }

  // 合约=>总可用余额 //availableBalance +全仓的未实现盈利estimatedProfit
  @computed get tigerAvailableBalance() {
    let precision = 4;
    const coinsPrecisionList = this.rootStore.coin.coinsPrecisionList;
    if (Reflect.has(coinsPrecisionList, 'USDT')) {
      precision = this.rootStore.coin.coinsPrecisionList['USDT'];
    }
    const res = this.tigerBalance.reduce(
      (previous, current) => previous + (Number(current.availableBalance) + Number(current.estimatedProfit)),
      0,
    );
    return formatAssetsPrecision(res, precision);
  }

  // 跟单=>总可用余额 //availableBalance +全仓的未实现盈利estimatedProfit
  @computed get copyAvailableBalance() {
    let precision = 4;
    const coinsPrecisionList = this.rootStore.coin.coinsPrecisionList;
    if (Reflect.has(coinsPrecisionList, 'USDT')) {
      precision = this.rootStore.coin.coinsPrecisionList['USDT'];
    }
    const res = this.copyBalance.reduce(
      (previous, current) => previous + (Number(current.availableBalance) + Number(current.estimatedProfit)),
      0,
    );
    return formatAssetsPrecision(res, precision);
  }

  // 跟单列表资产用这个 可用余额包括了全仓未实现盈亏 正数不加 负数相加 划转用
  @computed get copyBalanceProfitTransfer() {
    const crossedUnsettled = this.rootStore.futures.copyCrossedUnsettledProfitTotal || '0';
    const followList = this.rootStore.futures.currentFollowOrderListWithConfig;

    return this.copyBalance.map(item => {
      let crossedFloatProfit = new BigNumber(0);
      const coin = item.coin;
      followList.forEach((p: any) => {
        if (p.positionType !== 'CROSSED') return;
        const isMatch = coin === 'usdt'
          ? p.symbolName?.split('_')[1] === 'usdt'
          : p.symbolName?.split('_')[0] === coin;
        if (isMatch) {
          crossedFloatProfit = crossedFloatProfit.plus(p.floatProfit || 0);
        }
      });

      const realTimeAvailable = BigNumber.max(
        0,
        new BigNumber(item.availableBalance).plus(crossedFloatProfit),
      );

      return {
        ...item,
        availableBalanceProfit: BigNumber.max(0, realTimeAvailable.minus(crossedUnsettled)).valueOf(),
      };
    });
  }
  @computed get financiaAlllBalance() {
    return this.financialBalance.reduce((previous, current) => previous + Number(current.estimatedTotalAmount), 0);
  }

  // 合约 钱包余额
  @computed get tigerTotalBalance() {
    return this.tigerBalance.reduce((previous, current) => previous + Number(current.balance), 0);
  }

  // 合约=》总 占用保证金 marginEstimatedTotalAmount （crossedMargin+isolatedMargin+openOrderMarginFrozen）
  @computed get tigerCrossedMargin() {
    return this.tigerBalance.reduce((previous, current) => previous + Number(current.marginEstimatedTotalAmount), 0);
  }

  // 跟单=》总 占用保证金 marginEstimatedTotalAmount （crossedMargin+isolatedMargin+openOrderMarginFrozen）
  @computed get copyCrossedMargin() {
    return this.copyBalance.reduce((previous, current) => previous + Number(current.marginEstimatedTotalAmount), 0);
  }

  // 合约 总未实现盈亏  estimatedIsolatedProfit + estimatedProfit
  @computed get tigerProfitTotal() {
    return this.tigerBalance.reduce(
      (previous, current) => previous + (Number(current.estimatedIsolatedProfit) + Number(current.estimatedProfit)),
      0,
    );
  }

  // 跟单 总未实现盈亏  estimatedIsolatedProfit + estimatedProfit
  @computed get copyProfitTotal() {
    return this.copyBalance.reduce(
      (previous, current) => previous + (Number(current.estimatedIsolatedProfit) + Number(current.estimatedProfit)),
      0,
    );
  }

  // 合约 全仓未实现盈亏 -总
  @computed get tigerIsolatedProfit() {
    return this.tigerBalance.reduce((previous, current) => previous + Number(current.estimatedIsolatedProfit), 0);
  }

  // 合约 逐仓未实现盈亏 -总
  @computed get tigerProfitBalance() {
    return this.tigerBalance.reduce((previous, current) => previous + Number(current.estimatedProfit), 0);
  }

  // 合约 全仓未实现盈亏 -负数
  @computed get tigerProfitBalanceNegative() {
    const list = this.tigerBalance.filter(item => new BigNumber(item.estimatedProfit).lt(0));
    return list?.reduce((previous, current) => previous + Number(current.estimatedProfit), 0);
  }

  @action.bound
  setLoadingState(key: string, data: boolean) {
    // @ts-ignore
    this[key] = data;
  }

  @action.bound
  setBillPageInfo(data: ScrollPageInfo) {
    const origin = { ...this.billPageInfo };
    this.billPageInfo = { ...origin, ...data };
  }

  @action.bound
  setWithdrawDepositRecordsPageInfo(data: ScrollPageInfo) {
    const origin = { ...this.withdrawDepositRecordsPageInfo };
    this.withdrawDepositRecordsPageInfo = { ...origin, ...data };
  }

  @action.bound
  setInnerTransferRecordsPageInfo(data: ScrollPageInfo) {
    const origin = { ...this.innerTransferRecordsPageInfo };
    this.innerTransferRecordsPageInfo = { ...origin, ...data };
  }

  @action.bound
  setTransferRecordsPageInfo(data: ScrollPageInfo) {
    const origin = { ...this.transferRecordsPageInfo };
    this.transferRecordsPageInfo = { ...origin, ...data };
  }

  @action.bound
  setProfitData(data: any) {
    this.profitData = data;
  }

  @action.bound
  setHideZero(data: boolean) {
    this.hideZero = data;
  }

  @action.bound
  setTransferModal(data: boolean) {
    this.showTransferModal = data;
  }

  @action.bound
  setQuota(data: string | number) {
    this.quota = data;
  }

  @action.bound
  setSupportAccount(data: any) {
    this.supportAccount = data;
  }

  @action.bound
  setShowAsset(data: boolean) {
    Cookies.set('showAsset', JSON.stringify(Number(data)));
    this.showAsset = data;
  }

  @action.bound
  setWithdrawRecords(data: any) {
    this.wthdrawRecords = data;
  }
  @action.bound
  setInnerTransferRecords(data: any) {
    this.innerTransferRecords = data;
  }
  @action.bound
  setSupportCoin(data: any) {
    this.supportCoinList = data;
  }

  @action.bound
  setDepositRecords(data: any) {
    this.depositRecords = data;
  }

  @action.bound
  setTransferRecords(data: any) {
    this.transferRecords = data;
  }

  @action.bound
  setWithdrawDepositRecords(data: any) {
    this.withdrawDepositRecords = data;
  }

  @action.bound
  setBills(data: any) {
    this.bills = data;
  }

  @action.bound
  setBillTpye(data: any) {
    this.billTypes = data;
  }

  @action.bound
  setBalance(data: any) {
    const {
      financialBalance,
      otcBalance,
      phaseRate,
      profitAmount,
      spotBalance,
      tigerBalance,
      totalCynAmount,
      totalUsdtAmount,
      tigerSpuerBalance,
      copyBalance,
    } = data;

    Object.keys(data).forEach(item => {
      if (Array.isArray(data[item]) && data[item].length) {
        // @ts-ignore
        this[item] = data[item];
        // this.otcBalance = otcBalance;
        // this.spotBalance = spotBalance;
        // this.tigerBalance = tigerBalance;
        // this.tigerSpuerBalance = tigerSpuerBalance;
        // this.copyBalance = copyBalance;
      }
    });

    this.profitAmount = profitAmount;
    this.phaseRate = phaseRate;

    this.totalCynAmount = totalCynAmount;
    this.totalUsdtAmount = totalUsdtAmount;
  }

  @action
  setMyLeaderConfig(data: UserConfig) {
    this.userConfig = data;
  }

  @action.bound
  async fetchProfitData() {
    const result: any = await Axios.get(API.MY_PROFIT_STATS, {});
    if (result) {
      this.setProfitData(result);
    }
  }
  @action.bound
  async fetchMyLeaderConfig() {
    const result: any = await Axios.get(API.COPY_TRADE_USER, {});

    if (result) {
      this.setMyLeaderConfig(result);
    }
  }
  // 所有资产
  @action.bound
  async fetchBalance(params = { type: BALANCETYPE }) {
    this.setLoadingState('isFetchingBalance', true);
    const result: any = await Axios.get(getExchangeUrl().balance, {
      params,
    });
    if (result) {
      this.setBalance(result);

      this.setLoadingState('isFetchingBalance', false);
    }
  }

  // 综合账单
  @action.bound
  async fetchBills(params?: {
    id?: string;
    direction?: ScrollPaginationDirection;
    coin?: string;
    type?: string;
    startTime?: string | number | undefined;
    endTime?: string | number | undefined;
    limit?: number;
  }) {
    this.setLoadingState('isFetchingHistory', true);

    const result: any = await Axios.get(getExchangeUrl().bills, {
      params: {
        ...params,
      },
    });

    if (result) {
      const { items, hasPrev, hasNext } = result;
      this.setBills(items);
      this.setBillPageInfo({ hasPrev, hasNext });
    }
    this.setLoadingState('isFetchingHistory', false);
  }

  // 综合账单类型
  @action.bound
  async fetchBillType() {
    const result: any = await Axios.get(getExchangeUrl().confAllSpot);

    if (result) {
      this.setBillTpye(result);
    }
  }

  // 充值提现记录
  @action.bound
  async fetchWithdrawDepositRecord(params?) {
    this.setLoadingState('isFetchingWithdrawDepositRecord', true);
    const config: any = {
      params: {
        ...params,
      },
    };
    const result: any = await Axios.get(getExchangeUrl().withdrawDeposit, config);
    if (result) {
      const { items, hasPrev, hasNext } = result;
      if (params?.type === 1) {
        // 提现 1
        this.setWithdrawRecords(items);
      } else if (params?.type === 0) {
        // 充值 0
        this.setDepositRecords(items);
      } else if (params?.type === 3) {
        // 内部转账 3
        this.setInnerTransferRecords(items);
      } else {
        this.setWithdrawDepositRecords(items);
        // 总记录
      }
      if (params?.type === 3) {
        this.setInnerTransferRecordsPageInfo({ hasPrev, hasNext });
      } else {
        this.setWithdrawDepositRecordsPageInfo({ hasPrev, hasNext });
      }

      // this.setBalance(result);
    }
    this.setLoadingState('isFetchingWithdrawDepositRecord', false);
  }

  // 链上提现进度详情
  @action.bound
  async fetchWithdrawProgress(id: string) {
    return Axios.get(getExchangeUrl().withdrawProgress, { params: { id } });
  }

  // 划转记录
  @action.bound
  async fetchTransferList(params?) {
    this.setLoadingState('isFetchingWithdrawDepositRecord', true);
    const page = Number(params?.page || 1);
    const size = Number(params?.size || 10);
    const result: any = await Axios.get(getExchangeUrl().transferList, {
      params: {
        page,
        size,
        ...params,
      },
    });
    if (result) {
      const items = result.items || result.records || result.list || [];
      const total = result.total || result.totalCount;
      const hasPrev = typeof result.hasPrev === 'boolean' ? result.hasPrev : page > 1;
      const hasNext = typeof result.hasNext === 'boolean'
        ? result.hasNext
        : total
          ? page * size < Number(total)
          : items.length >= size;
      this.setTransferRecords(items || []);
      this.setTransferRecordsPageInfo({ hasPrev, hasNext });
    }
    this.setLoadingState('isFetchingWithdrawDepositRecord', false);
  }

  // 可用额度
  @action.bound
  async fetchQuota(params) {
    const result: any = await Axios.get(getExchangeUrl().quota, { params });

    if (result) {
      this.setQuota(result);
    }
  }

  // 支持的划转账户
  @action.bound
  async fetchSupportAccount() {
    const result: any = await Axios.get(getExchangeUrl().supportAccount);

    if (result) {
      this.setSupportAccount(result);
    }
  }

  // 支持的划转的币种列表
  @action.bound
  async fetchSupportCoin() {
    const result: any = await Axios.get(getExchangeUrl().supportCoin);

    if (result) {
      this.setSupportCoin(result);
    }
  }

  // 创建划转
  @action.bound
  async fetchTransfer(data) {
    clearTimeout(this.transferTimer);
    const result: any = await Axios.post(getExchangeUrl().transferBalance, JSON.stringify(data), {
      headers: {
        'Content-Type': 'application/json', // 请求载荷
      },
    }).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });
    if (result) {
      Notification.success({
        message: result,
        offset: 60,
        duration: 2000,
      });

      this.fetchBalance();
      // 划转后：合约页展示使用的是 futures.balanceData -> asset.balance / asset.displayCoinBalance
      // 这里需要同步刷新 asset 侧的余额明细，否则 orderForm/asset 不会重渲染
      try {
        const { asset, underlying, ticker } = this.rootStore || {};
        const underlyingType = underlying?.currentUnderlying;
        const isUBased = underlying?.isUBased;
        const baseCoin = ticker?.currentSymbolConfig?.baseCoin;

        const fallbackCoin = (isUBased ? 'usdt' : baseCoin)?.toString()?.toLowerCase?.() || 'usdt';
        const balanceCoin = asset?.balance?.coin || '';
        const displayCoin = asset?.displayCoinBalance?.coin || '';

        const coinsToRefresh = [balanceCoin, displayCoin, fallbackCoin]
          .filter(Boolean)
          .map((c: string) => c.toLowerCase());
        const uniqueCoins = Array.from(new Set(coinsToRefresh));

        if (asset?.fetchBalanceDetail && underlyingType) {
          await Promise.allSettled(
            uniqueCoins.map((coin: string) => asset.fetchBalanceDetail({ coin, underlyingType })),
          );
        }
        if (asset?.fetchDisplayCoinBalance && underlyingType && displayCoin) {
          await asset.fetchDisplayCoinBalance({ coin: displayCoin.toLowerCase(), underlyingType });
        }
      } catch (e) {
        // do nothing
      }
      this.transferTimer = setTimeout(() => {
        this.setTransferModal(false);
      }, 1500);
      return Promise.resolve(result);
    }
  }
}
